import React from 'react';
import { DynamicBlockList } from '~/templates/blocks';
import { useProfile } from '~/templates/pages/components/P125MyProfilePage/context/ProfileContext';
import BonusBalance from '../BonusBalance/BonusBalance';
import styles from './ProfileTabs.module.scss';

const ProfileOverview: React.FC = () => {
    const { pageElements, bottomPageElements } = useProfile();

    return (
        <div className={styles.tabContent}>
            {pageElements && <DynamicBlockList elements={pageElements} />}

            <div className={styles.inner}>
                <div className={styles.overviewContent}>
                    <BonusBalance />
                </div>
            </div>

            {bottomPageElements && <DynamicBlockList elements={bottomPageElements} />}
        </div>
    );
};

export default ProfileOverview;
